import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { EXPENSE_APPROVED_ITEMS_BASE_KEY } from '@webapp/modules/expense/query-configs/expense'

export const useMutateCorrectExpenseItemAccountCodeInline = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    void,
    RepoError,
    { expenseItemId: number; accountId: number }
  >({
    mutationFn: ({ expenseItemId, accountId }) =>
      expenseRepository.correctItemBudgets([{ expenseItemId, accountId }]),
    onSuccess: () => {
      // Keeps the cached row's account consistent; the sibling
      // 'approved-items-count' badge key is deliberately untouched
      queryClient.invalidateQueries({
        queryKey: EXPENSE_APPROVED_ITEMS_BASE_KEY,
      })
    },
  })

  return {
    correctAccountCode: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
